/**
 * Production-safe logging utility
 * Automatically disables logging in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';

class Logger {
  constructor() {
    this.enabled = isDevelopment;
  }

  log(...args) {
    if (this.enabled) {
      console.log(...args);
    }
  }

  error(...args) {
    // Always log errors, even in production
    console.error(...args);
  }

  warn(...args) {
    if (this.enabled) {
      console.warn(...args);
    }
  }

  debug(...args) {
    if (this.enabled) {
      console.log('[DEBUG]', ...args);
    }
  }

  info(...args) {
    if (this.enabled) {
      console.log('[INFO]', ...args);
    }
  }
}

// Export singleton instance
export default new Logger();

